import React, { useState, useEffect, useContext } from "react";
import { AnchorComponent, ButtonComponent } from "../elements";
import { TranslatorContext } from "../../context/Translator";
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";


export default function SimsTableComponent({ thead, tbody,refreshPage }) {

    const { t } = useContext(TranslatorContext);
        const navigate = useNavigate();
    
    const [data, setData] = useState([]);


    useEffect(()=> { setData(tbody) }, [tbody]);

    
    const handleRowClick = (item) => {
        navigate(`/sim/${item.id}`);
    };
    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => {
                        let backgroundColor = 'white';
                        if(item.status === "pending"){

                        }else if(item.status === "approved"){
                            backgroundColor = '#90EE90';
                        }
                        else if(item.status === "rejected"){
                            backgroundColor = '#FF7F7F';
                        }
                        return (
                            <tr key={ index } style={{backgroundColor: backgroundColor}}> 
                                <td title={ item.sim_number }>
                                    <div className="mc-table-profile">
                                        <p>{ item.sim_number }</p>
                                    </div>
                                </td>
                                <td title={ item.serial_number }>{ item.serial_number }</td>
                                <td title={ item.customer_id }>{ item.customer_id}</td>
    
                                <td title={ item.customer_name }>{ item.customer_name}</td>
                                <td title={ item.puk }>{ item.puk}</td>
    
                                <td title={ item.created }>{ moment.utc(item.created_at).local().format('yyyy-MM-DD HH:mm:ss') }</td>
                                <td>
                                    {
                                        localStorage.getItem('permissions').includes('update sim') && 
                                        <AnchorComponent onClick={() => handleRowClick(item)} to={'#'} title="View" className="material-icons view">{ "visibility" }</AnchorComponent>
                                    }
                                    
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            
           
            
        </div>
    )
}